import { REACT_APP_ARTICULOS_BUCKET } from "src/config/environment"
import { uploadFileToBucket } from "src/utils/s3Client"
import { FormValuesParam } from "../Form.types"

export const uploadImage = async (product: FormValuesParam) => {
    if (product.foto) {
        if (typeof product.foto !== "string") {
            const resourceName = `${product.nombre || "articulo"}_${Number(product.contenido)}_${product.unidad}`.toLowerCase()
            const link = await uploadFileToBucket({
                bucket: REACT_APP_ARTICULOS_BUCKET ?? "",
                folder: "articulos",
                resourceName,
                file: product.foto,
            })
            return link || null
        } else {
            return product.foto
        }
    } else {
        return null
    }
}
